import type { GetStaticProps, GetServerSideProps } from "next";
import { ApiService } from "services/server";
import { Map } from "views";
import { normalizeMap } from "utils/normalizer";
import { REVALIDATE_TIME } from "utils";
import { checkEmpty } from "utils/newFunction";

function MapPage({ data }) {
  return <Map data={data} />;
}

// export const getStaticProps: GetStaticProps = async ({ locale }) => {
//   const apiService = new ApiService(locale);

//   const requests = [
//     apiService.getMap(), // 0
//   ];

//   const response = await ApiService.multipleRequest(requests);

//   if (checkEmpty(...response)) {
//     throw new Error();
//   }

//   return {
//     props: {
//       data: {
//         map: normalizeMap(response?.[0]),
//         useDefaultHrefLang: true,
//       },
//     },
//     revalidate: REVALIDATE_TIME,
//   };
// };

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const apiService = new ApiService(locale);
  try {
    const requests = [
      apiService.getMap(), // 0
    ];

    let response = [];
    try {
      response = await ApiService.multipleRequest(requests);
    } catch (error) {
      console.log("error", error);
    }

    return {
      props: {
        data: {
          map: normalizeMap(response?.[0]),
          useDefaultHrefLang: true,
        },
      },
    };
  } catch (err) {
    return {
      redirect: {
        destination: "/500",
        permanent: false,
      },
    };
  }
};

export default MapPage;
